import React from "react";
import { Link } from "react-router-dom";
import BrandLogo from "@components/BrandLogo";
import ActivityPoints from "@components/ActivityPoints";
import ActivityType from "../../components/ActivityType";
import { isContestActivation, parseCMSBold } from "@app/Helpers.js";
import ArrowTip from "./img/arrow-tip-button.svg?react";
import "./style.scss";
import DOMPurify from "dompurify";

export default function ActivityCard({
  mobileImg,
  desktopImg,
  imgDesc,
  copy,
  points,
  brands,
  completed = false,
  ident,
  type,
  highlighted,
  href,
  date = null,
  className = "",
  description = "",
  disabled = false,
  onClick,
  withButton = false,
  buttonCopy = "Mehr erfahren",
}) {
  const contest = isContestActivation({ ident, type });

  const determineLink = () => {
    if (contest) return `/contest/${ident}`;
    return `/activities/${ident}`;
  };

  return (
    <div
      className={`ultra-activity-card-component ${
        completed && !contest ? "completed" : ""
      } ${className ? className : ""} ${highlighted ? "highlighted" : ""} ${disabled ? "disabled" : ""}`}
    >
      <Link
        to={completed && !contest ? "/coupons" : determineLink()}
        onClick={onClick}
      >
        <div className="inner">
          <div className="img-wrapper">
            {/* {completed && type !== "Contest" && (
              <div className="award-link">
                <span>Punkte eintauschen</span> <ArrowTip />
              </div>
            )} */}
            {date && (
              <div className="image-copy">Du erhältst Zugang am: {date}</div>
            )}
            <picture>
              <source media="(min-width: 1020px)" srcSet={desktopImg} />
              <img src={mobileImg} alt={imgDesc} />
            </picture>
          </div>
          {/* <BrandLogo brands={brands} /> */}

          <div className="award-info">
          {type && <ActivityType type={completed ? "completed" : type} />}

            <p
              className="copy"
              dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(parseCMSBold(copy))}}
            />
            {/* <hr /> */}
            <div className="divider"></div>
            <div className="award-status">
              {description && !withButton && (
                <p
                  className="description"
                  dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(description)}}
                />
              )}
              {withButton && (
                <div className="static-cta">
                  {" "}
                  <span>{buttonCopy}</span>
                </div>
              )}

              {/* <CostStatus
                points={points}
                availableForStatus={availableForStatus}
                level={level}
              />
              <ProgressBarStatus
                partner={partner}
                partnerAvailable={partnerAvailable}
                inStock={inStock}
                balance={data?.consumer?.balance}
                points={points}
                availableForStatus={availableForStatus}
              />
              <AwardStatus
                partner={partner}
                partnerAvailable={partnerAvailable}
                inStock={inStock}
                balance={data?.consumer?.balance}
                value={points}
                availableForStatus={availableForStatus}
              /> */}
              {/* <AwardStatus
                partner={partner}
                partnerAvailable={partnerAvailable}
                inStock={inStock}
                balance={data?.consumer?.balance}
                value={points}
                availableForStatus={availableForStatus}
              />  */}
            </div>
          </div>
        </div>
      </Link>
    </div>
  );
}
